import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import axios from "axios";
import { useAdminAuth } from "./AdminAuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Guards every admin route:
 *   - Bounces unauthenticated users to /admin/login
 *   - If a verified TOTP factor exists AND the current Supabase session is
 *     still aal1, forces the /admin/mfa-challenge screen. The challenge
 *     endpoint /api/admin/mfa/status is callable at aal1 by design.
 */
export default function AdminRoute() {
  const { admin, session, checking } = useAdminAuth();
  const location = useLocation();
  const [mfa, setMfa] = useState({ loading: true, enrolled: false, aal: "aal1" });

  useEffect(() => {
    let cancelled = false;
    if (!session?.access_token) { setMfa({ loading: false, enrolled: false, aal: "aal1" }); return; }
    axios.get(`${API}/admin/mfa/status`, { headers: { Authorization: `Bearer ${session.access_token}` } })
      .then(({ data }) => { if (!cancelled) setMfa({ loading: false, ...data }); })
      .catch(() => { if (!cancelled) setMfa({ loading: false, enrolled: false, aal: "aal1" }); });
    return () => { cancelled = true; };
  }, [session]);

  if (checking || mfa.loading) {
    return (
      <div style={{ minHeight: "100vh", background: "#0A0A0B", color: "#5A5A62", display: "grid", placeItems: "center", fontFamily: "JetBrains Mono, monospace", fontSize: 12, letterSpacing: "0.16em", textTransform: "uppercase" }}>
        CHECKING ACCESS...
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin/login" replace />;

  const needChallenge = mfa.enrolled && mfa.aal !== "aal2";
  const onChallenge = location.pathname.endsWith("/admin/mfa-challenge");
  if (needChallenge && !onChallenge) {
    return <Navigate to="/admin/mfa-challenge" replace />;
  }
  if (!needChallenge && onChallenge) {
    return <Navigate to="/admin" replace />;
  }
  return <Outlet />;
}
